import apiFetch from '../apiFetch'

export default function (associatedCostsValues, uoId, token) {
  let body = {
    organizedUnitId: uoId,
    isDeleted: false,
    associatedCostTypeLanguages: associatedCostsValues
  }
  return apiFetch({
    endPoint: 'associatedCostType',
    method: 'POST',
    body: body,
    token: token
  })
}
